@if(filledInfo && sectionData){
<div nz-row>
  @if(isAttrAvailable('trackingNumber')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'trackingNumber']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("trackingNumber").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.trackingNumber ? filledInfo?.trackingNumber : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('id')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'id']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("id").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ id ? id : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('participantProgramCode')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'participantProgramCode']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("participantProgramCode").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ programCode ? programCode : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('associationType')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'associationType']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("associationType").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.associationType }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('providerType')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'providerType']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("providerType").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ providerType }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('decisionComments')){

  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'decisionComments']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("decisionComments").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.decisionComments ? filledInfo?.decisionComments : '-'}}
      </div>
    </div>
  </div>
  } @if(isAttrAvailable('applicationAssignedToUser') && showAssignedTo){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationAssignedToUser']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("applicationAssignedToUser").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.applicationAssignedToUser ?
        filledInfo?.applicationAssignedToUser : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('applicationStage')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationStage']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("applicationStage").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.applicationStage ?
        getLookupValue(getLookup('Lead_Application_Stage'),filledInfo?.applicationStage)
        : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('finalApplicantDisposition')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'finalApplicantDisposition']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("finalApplicantDisposition").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.finalApplicantDisposition ?
        filledInfo?.finalApplicantDisposition : '-' }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('applicationStatus')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationStatus']">
    <div nz-row>
      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("applicationStatus").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.applicationStatus }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('applicationSubmissionDate')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationSubmissionDate']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("applicationSubmissionDate").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{
        (filledInfo?.applicationSubmissionDate)
        |
        date:'MM/dd/yyyy'
        }}
      </div>
    </div>
  </div>

  }@if(isAttrAvailable('applicationSource')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'applicationSource']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("applicationSource").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.applicationSource }}
      </div>
    </div>
  </div>
  }
  @if(isAttrAvailable('referralSource')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'referralSource']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("referralSource").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.referralSource }}
        @if(filledInfo?.referralSource?.toLowerCase() === 'other' && filledInfo?.otherReferralSource) {
        ({{ filledInfo?.otherReferralSource }})
        }
      </div>
    </div>
  </div>
  }
  @if(showOtherReferralSource && isAttrAvailable('otherReferralSource')){
  <div nz-col nzSpan="12" [nzXs]="24" [nzSm]="12" [nzLg]="12" [nzXXl]="12"
    *authorizeFieldView="[pageId, tabId, 'ApplicationDetails', 'otherReferralSource']">
    <div nz-row>

      <div nz-col nzSpan="12" [nzXs]="9" ngClass="font-weight-600 pt-2 ">
        {{ getAttributes("otherReferralSource").label }}
      </div>
      <div nz-col nzSpan="12" [nzXs]="15" ngClass="pt-2  mobile-value-left-paddiing">
        {{ filledInfo?.otherReferralSource }}
      </div>
    </div>
  </div>
  }
</div>
}@else{
<nz-row>
  <p>No Data found</p>
</nz-row>
}